
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-more",
      function () {
        return require("private-next-pages/about-more.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-more"])
      });
    }
  